export default __webpack_public_path__ + "static/media/img_2.f4f4bff3.jpeg";